import React from 'react';
function Icon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "none",
    viewBox: "0 0 20 20",
    className: "rocket-body"
  }, React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.683 14.732l-3.39-3.39-4.025-.805c-.487-.098-.78-.488-.878-.878 0-.488.195-.879.683-1.171L6.83 5.366c.363-.182.895-.194 1.203.119a13.948 13.948 0 011.724-1.973C13.561 0 19.122 0 19.317 0H20v.683c0 .195-.098 5.756-3.512 9.56a13.793 13.793 0 01-1.871 1.65c.309.374.295.819.115 1.18L11.61 18.83c-.293.488-.683.683-1.073.683h-.196c-.487-.097-.78-.39-.878-.878l-.78-3.902zm4.779-2.046a26.234 26.234 0 01-3.398 1.803l.668 3.17 2.73-4.973zm-6.221-6.03l-.021-.022-4.976 2.732 3.22.678C5.794 9.286 6.397 8 7.24 6.655zm1.93 6.71l-2.537-2.537c.488-1.17 1.951-4.39 4.098-6.341 2.634-2.44 6.439-3.025 7.902-3.122-.098 1.463-.683 5.268-3.122 7.902-2.049 2.147-5.17 3.61-6.341 4.098zM13.366 4c.683 0 1.366.293 1.854.78 1.073.976 1.073 2.635 0 3.708-.488.488-1.171.78-1.854.78a2.665 2.665 0 01-2.634-2.634A2.665 2.665 0 0113.366 4zm-1.073 3.707c.585.586 1.56.586 2.146 0a1.531 1.531 0 000-2.146c-.293-.293-.683-.488-1.073-.488-.39 0-.78.195-1.073.488a1.531 1.531 0 000 2.146z",
    clipRule: "evenodd"
  }));
}
function FullFlame() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10",
    fill: "none",
    viewBox: "0 0 10 10",
    className: "rocket-flame"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 10v-.683C.098 3.854 3.61 1.122 5.463.341L5.66.244l.487 1.268-.195.098S1.756 3.366 1.366 8.634c5.366-.39 7.024-4.488 7.024-4.488l.098-.195 1.268.488-.097.195C8.976 6.488 6.146 10 .683 10H0z"
  }));
}
export const Rocket = _ref => {
  let {
    active
  } = _ref;
  return React.createElement("span", {
    className: "navbar-rocket-wrapper",
    "aria-hidden": "true"
  }, React.createElement("span", {
    className: "navbar-rocket-icons-wrapper ".concat(active ? 'active' : '')
  }, React.createElement(FullFlame, null), React.createElement(Icon, null)));
};